/**
 * Application constants and configuration
 */

// Maximum message length in characters
export const MAX_MESSAGE_LENGTH = 2000;

// Survey conversation control signals
export const END_CONVERSATION_SIGNAL = "__END_CONVERSATION__";
